import dayjs from "dayjs";

export const formatRequiredLocalDateInput = (value: unknown, fieldName: string): string => {
    if (value === null || value === undefined || value === "") {
        throw new Error(`${fieldName} is required.`);
    }

    const parsed = dayjs(value as any);
    if (!parsed.isValid()) {
        throw new Error(`${fieldName} must be a valid date.`);
    }

    return parsed.format("YYYY-MM-DD");
};

export const formatOptionalLocalDateInput = (value: unknown, fieldName: string): string | null => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    return formatRequiredLocalDateInput(value, fieldName);
};
